import React from 'react';
import { createStructuredSelector } from 'reselect';
import { getErrorObjectSelector } from '../../appContainer/selectors';
import { useSelector } from 'react-redux';
import { ERROR_HANDLER_TYPES } from '../../utils';
import SnakcBarHandler from './components/SnackbarHandler';

const stateSelector = createStructuredSelector({ errorObj: getErrorObjectSelector });

const ErrorHandler = () => {
  const { errorObj } = useSelector(stateSelector);

  switch (errorObj.type) {
    case ERROR_HANDLER_TYPES.SNACKBAR: {
      return <SnakcBarHandler key={errorObj.key} errorObj={errorObj} />;
    }
    default: {
      return null;
    }
  }
};

export default ErrorHandler;
